import React from 'react'

export default function HomeSection() {
   return (
        <div className="home-section" id="home">
        </div>
    )
}
